module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/default-127363fed38cdea23389fd32310c6413.png";